import { Link } from 'react-router-dom';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': '关于韩漫之家',
    'description': '韩漫之家是一个专注于免费韩国漫画在线阅读的平台，提供高清韩国漫画资源。',
    'url': 'https://www.manhuazhijia.com/about',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '韩漫之家',
      'url': 'https://www.manhuazhijia.com/',
    },
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'name': '首页',
          'item': 'https://www.manhuazhijia.com/',
        },
        {
          '@type': 'ListItem',
          'position': 2,
          'name': '关于我们',
          'item': 'https://www.manhuazhijia.com/about',
        },
      ],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '韩漫之家提供哪些类型的漫画？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家提供恋爱、动作、奇幻、悬疑、喜剧、剧情、恐怖、BL等多种类型的韩国漫画，满足不同读者的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        'name': '韩漫之家的漫画需要付费吗？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家所有漫画均为免费在线阅读，用户无需支付任何费用即可享受高清漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        'name': '如何开始阅读漫画？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '您可以通过首页推荐、分类浏览或搜索功能找到感兴趣的漫画，点击漫画封面进入详情页，然后选择章节即可开始阅读。',
        },
      },
      {
        '@type': 'Question',
        'name': '漫画更新频率是怎样的？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '各漫画的更新频率取决于原始发布方的更新周期。我们会在漫画新章节发布后尽快同步更新，确保读者能够及时阅读到最新内容。',
        },
      },
      {
        '@type': 'Question',
        'name': '韩漫之家支持哪些设备阅读？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家支持在电脑、平板和手机等多种设备上阅读，采用响应式设计，在任何屏幕尺寸下都能获得良好的阅读体验。',
        },
      },
    ],
  };

  return (
    <>
      <head>
        <title>关于我们 - 免费韩漫平台介绍 - 韩漫之家</title>
        <meta name="description" content="韩漫之家是一个专注于免费韩漫和韩国漫画下拉式在线阅读的平台，拥有高清漫画大全资源。在这里了解我们的品牌故事、用户口碑和联系方式。" />
        <meta name="keywords" content="韩漫之家,免费韩漫,韩国漫画在线阅读,关于韩漫之家,高清漫画平台,漫画网站介绍" />
        <link rel="canonical" href="https://www.manhuazhijia.com/about" />
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </head>

      <main className="pt-16">
        {/* Page Header */}
        <div className="bg-gradient-to-b from-primary-500/10 to-background-50 py-10 md:py-14">
          <div className="px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <nav className="flex items-center justify-center gap-1.5 text-sm mb-4" aria-label="面包屑导航">
                <Link to="/" className="text-foreground-500 hover:text-primary-600 transition-colors">首页</Link>
                <span className="text-foreground-300">/</span>
                <span className="text-foreground-900 font-medium">关于我们</span>
              </nav>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">关于韩漫之家</h1>
              <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                让每一位漫迷都能享受<strong>免费韩漫</strong>带来的阅读乐趣
              </p>
            </div>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-book-open-line text-2xl text-background-50"></i>
              </div>
              <h2 className="mt-4 text-xl md:text-2xl font-heading font-bold text-foreground-950">品牌介绍</h2>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  <strong>韩漫之家</strong>创建于2023年，是一个专注于为中文读者提供<strong>免费韩漫</strong>和<strong>韩国漫画下拉式在线阅读</strong>的平台。我们深知漫画爱好者的需求，致力于打造一个内容丰富、体验流畅的<strong>高清漫画大全</strong>网站。
                </p>
                <p>
                  在韩漫之家，您可以找到来自韩国的优质漫画作品，涵盖了<strong>恋爱、动作、奇幻、悬疑、喜剧、剧情、恐怖、BL</strong>等多种类型。无论您是喜欢甜蜜浪漫的爱情故事，还是热衷于热血沸腾的动作冒险，亦或是沉迷于烧脑悬疑的推理剧情，这里都有适合您的作品。
                </p>
                <p>
                  我们采用<strong>下拉式在线阅读</strong>模式，为您提供连贯流畅的阅读体验，无需频繁翻页，让阅读过程更加沉浸和舒适。所有漫画资源均为<strong>高清画质</strong>，确保每一个画面细节都能清晰呈现，让韩漫的精美画风得到最佳展现。
                </p>
                <p>
                  韩漫之家始终坚持以用户为中心，持续更新漫画资源，优化阅读体验，努力成为中文世界最受欢迎的韩国漫画阅读平台之一。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">我们的数据</h2>
              <p className="mt-2 text-sm text-foreground-500">用数据说话，见证韩漫之家的成长</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { value: '500+', label: '漫画作品' },
                { value: '50万+', label: '日活跃用户' },
                { value: '99.8%', label: '服务稳定性' },
                { value: '4.9', label: '用户评分' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-5 rounded-xl bg-background-50">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{stat.value}</div>
                  <div className="mt-2 text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">用户口碑</h2>
              <p className="mt-2 text-sm text-foreground-500">听听漫迷们怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  name: '漫迷小王',
                  content: '韩漫之家的漫画资源真的很全！我追的《我独自升级》和《全知读者视角》都有，画质清晰，阅读流畅，是我用过最好的免费韩漫平台。',
                  rating: 5,
                },
                {
                  name: '追漫达人',
                  content: '下拉式阅读体验太棒了！不用频繁翻页，一口气看完一整话。分类也很清晰，找漫画非常方便。推荐给所有韩漫爱好者！',
                  rating: 5,
                },
                {
                  name: '漫画新手',
                  content: '刚入坑韩漫，韩漫之家的推荐功能帮我找到了很多好作品。界面简洁美观，更新速度也很快，已经推荐给身边的朋友了。',
                  rating: 5,
                },
                {
                  name: '资深读者',
                  content: '对比过很多漫画网站，韩漫之家的阅读体验是最好的。高清画质、流畅加载、更新及时，每一方面都做得非常到位。',
                  rating: 5,
                },
                {
                  name: '轻度用户',
                  content: '平时工作忙，碎片时间看看漫画放松。韩漫之家手机端阅读体验很好，随时随地都能看，而且完全免费，太良心了。',
                  rating: 5,
                },
                {
                  name: '学生党',
                  content: '免费又高清，对学生党太友好了！收藏了很多喜欢的漫画，每天追更已经成为我的日常。希望越做越好！',
                  rating: 5,
                },
              ].map((review, i) => (
                <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, j) => (
                      <div key={j} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  <div className="mt-3 flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
                      {review.name[0]}
                    </div>
                    <span className="text-xs font-medium text-foreground-700">{review.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">联系我们</h2>
              <p className="mt-2 text-sm text-foreground-500">有任何问题或建议，欢迎与我们取得联系</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8">
              <div className="p-6 rounded-xl bg-background-50 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">电子邮件</h3>
                <p className="mt-1 text-sm text-foreground-500">contact@manhuazhijia.com</p>
                <p className="text-xs text-foreground-400 mt-1">工作日24小时内回复</p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">微信公众号</h3>
                <p className="mt-1 text-sm text-foreground-500">韩漫之家</p>
                <p className="text-xs text-foreground-400 mt-1">关注获取最新漫画资讯</p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">办公地址</h3>
                <p className="mt-1 text-sm text-foreground-500">中国 · 北京</p>
                <p className="text-xs text-foreground-400 mt-1">朝阳区建国路88号</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">常见问题</h2>
              <p className="mt-2 text-sm text-foreground-500">常见问题解答，帮您快速了解韩漫之家</p>
            </div>
            <div className="space-y-3">
              {[
                { q: '韩漫之家提供哪些类型的漫画？', a: '韩漫之家提供恋爱、动作、奇幻、悬疑、喜剧、剧情、恐怖、BL等多种类型的韩国漫画，满足不同读者的阅读需求。' },
                { q: '韩漫之家的漫画需要付费吗？', a: '韩漫之家所有漫画均为免费在线阅读，用户无需支付任何费用即可享受高清漫画阅读体验。' },
                { q: '如何开始阅读漫画？', a: '您可以通过首页推荐、分类浏览或搜索功能找到感兴趣的漫画，点击漫画封面进入详情页，然后选择章节即可开始阅读。' },
                { q: '漫画更新频率是怎样的？', a: '各漫画的更新频率取决于原始发布方的更新周期。我们会在漫画新章节发布后尽快同步更新，确保读者能够及时阅读到最新内容。' },
                { q: '韩漫之家支持哪些设备阅读？', a: '韩漫之家支持在电脑、平板和手机等多种设备上阅读，采用响应式设计，在任何屏幕尺寸下都能获得良好的阅读体验。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl">
                  <summary className="px-5 py-4 flex items-center justify-between cursor-pointer text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors">
                    <span>{faq.q}</span>
                    <div className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}